import { render } from "./BusinessCalendar.vue?vue&type=template&id=497bbd66"
import script from "./BusinessCalendar.vue?vue&type=script&lang=js"
export * from "./BusinessCalendar.vue?vue&type=script&lang=js"

import "./BusinessCalendar.vue?vue&type=style&index=0&id=497bbd66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__